<template>
  <div class="wrapper">
    <img
      :src="require('@/assets/images/boxes-front.png')"
      class="boxes-front"
      draggable="false"
      alt=""
    />
    <img
      :src="require('@/assets/images/boxes-back.png')"
      class="boxes-back"
      draggable="false"
      alt=""
      ref="back"
    />
  </div>
</template>

<script>
import Rellax from 'rellax'

export default {
  name: 'BoxesSeparator',
  mounted () {
    // eslint-disable-next-line
    const rellax = new Rellax(this.$refs.back, {
      speed: -2,
      center: true
    })
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  margin-top: 150px;
  margin-bottom: -1px;
  font-size: 0;
  width: 100%;
  height: 458px;
}

.boxes-front,
.boxes-back {
  width: 1920px;
  height: auto;
  user-select: none;
  pointer-events: none;
  position: absolute;
  left: calc(50% - 960px);
}

.boxes-front {
  z-index: 2;
  height: 458.05px;
  top: 0;
}

.boxes-back {
  z-index: 1;
  bottom: 100px;
  height: 420.38px;
}
</style>
